// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"ModalEditPolicyDeposit_ModalHeader__qgMIc","ModalBody":"ModalEditPolicyDeposit_ModalBody__flBGB","ButtonClose":"ModalEditPolicyDeposit_ButtonClose__2fO7G"};